import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail } from "lucide-react";

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/newsletter").then((r) => setItems(r.data)); }, []);

  return (
    <div data-testid="admin-newsletter-page">
      <div className="mb-6">
        <div className="eyebrow mb-2">Marketing</div>
        <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">Newsletter subscribers</h1>
        <p className="mt-1 text-sm text-slate-600">{items.length} active subscriber{items.length === 1 ? "" : "s"}</p>
      </div>
      <div className="border border-slate-200 rounded-md bg-white overflow-hidden">
        {items.length === 0 ? (
          <div className="p-12 text-center text-slate-500"><Mail className="w-8 h-8 mx-auto mb-2 text-slate-300" strokeWidth={1.5}/>No subscribers yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200 font-mono text-[10px] uppercase tracking-widest text-slate-500">
              <tr><th className="text-left px-5 py-3">Email</th><th className="text-left px-5 py-3">Subscribed</th></tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.email} className="border-b border-slate-100 last:border-b-0">
                  <td className="px-5 py-3 text-slate-900">{s.email}</td>
                  <td className="px-5 py-3 text-slate-500 text-xs">{new Date(s.subscribed_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
